export default {
    Dashboard : 999, //Tổng quan
    Estimate : 1, //Lập dự toán
    EstimateSumary : 2, //Tổng hợp
    Dictionary : 3, //Danh mục
    Examine : 4, //kiểm tra
    Allocation : 60, //Phân bổ
    ObserveImplementation : 70, //Đánh giá tình hình thực hiện
    Login : 5, //Đăng nhập
    Logout : 99, //Đăng xuất

    //các màn hình danh mục
    ExpenseMission : 6, //danh mục Nhiệm vụ chi
    Project : 7, //danh mục CTMTDA
    BudgetSource : 8, //danh mục Nguồn kinh phí
    DictionaryBusiness : 9, //danh mục thu HDSN và DV
    DictionaryFees : 10, //danh mục Phí lệ phí
    BudgetChapter : 11, //danh mục chương
    BudgetKindItem : 12, //danh mục loại khoản
    BudgetItem : 13, //danh mục mục - tiểu mục
    StateBudget : 101, //danh mục thu NSNN
    DictionaryInvest : 102, // danh mục chi đầu tư
    RegularExpense : 103, // danh mục chi thường xuyên
    ProgramAndProjectExpense : 104, // danh mục chi CTMT
    GroupBudget : 105, // danh mục chương loại khoản
    RevenueOther : 106, // danh mục thu khác
    ExpenseOther : 107, // danh mục thu khác
    // các màn hình thiết lập
    InformationUnitManagement : 14, //thông tin đơn vị
    UserManagement : 15, // danh sách người dùng
    RoleManagement : 16, //Quản lý vai trò

    //các tab của lập dự toán
    EstimateRevenue : 17, //Lập dự toán thu
    EstimateExpenditureSummary : 18, //lập dự toán chi
    EstimateSynthetic : 19, //tổng hợp dự toán

    ImportEstimateArrgrateExpenseRegular : 71,//Nhập khẩu dự toán tiết kiệm 10% của chi thường xuyên
    ImportEstimateArrgrateSaveSalaryRegularSTC : 72,//Nhập khẩu dự toán tiết kiệm 10% của chi thường xuyên

    GettingStarted : 20, //getting

    EstimateExpenseRecipt : 22, //lập dự toán thu phí lệ phí
    EstimateExpenditureDetail : 23, //chi tiết dự toán chi
    EstimateBASDetailReceipt : 24, // chi tiết dự toán thu HĐSNDV
    ConfirmSentEstimate : 26, //Cấp dưới nộp dự toán
    EstimateStateBudgetCollection : 25, // chi tiết dự toán thu NSNN
    EstimateRevenueOtherWards : 27, // chi tiết dự toán thu khác

    //Các tab kiểm tra
    ExamineAllOrganization : 30, //Tab danh sách đơn vị
    ExamineNotSubmit : 31, //Tab chưa nộp dự toán
    ExamineNotCheck : 21, //tab chưa kiểm tra
    ExamineDiscussion : 32, //Tab đang thảo luận
    ExamineDone : 33, //Tab hoàn thành
    ExamineDetailOrganization : 34,//Màn hình danh sách kiểm tra theo đơn vị
    ExamineAdjust : 35,//Custome riêng cho màn hình Chuyển lĩnh vực để đo đếm
    ClariyContent : 36, // Phê duyệt nội dung

    //Các tab báo cáo
    ReportList : 40,

    //Các tab Tổng hợp
    SummaryGeneral : 50, //Tab Tổng hợp
    SummaryOverview : 51, //Phân tích tổng quan
    SummaryBudgetState : 52, //Nguồn NSNN
    SummaryFees : 53, //Nguồn Phí lệ phí
    SummaryActivitiService : 54, //Nguồn HĐSNDV
    SummarySentToParent : 56, //Nộp dự toán lên cấp trên

    //Các tab Phân bổ
    AllocationSuperior : 61,
    AllocationImplementation : 62,
    AllocationDecision : 63,
    SummaryEstimate : 64, // tổng hợp dự toán
    AllocationSuperiorSTC : 65,// nhận phương án phân bổ từ cấp trên (stc)
    FollowDeliver : 66, // Theo dõi giao 

    //Các tab Danh mục
    EstimateFormSetting : 67, // Mẫu dự toán chi thường xuyên
    DetailEstimateFormSetting : 68, // Chi tiết Mẫu dự toán chi thường xuyên
    AllocationDecisionSelected : 69, // Giao dự toán

    EnactDictionaryConfig : 70, // Ban hành danh mục

    BeforeData : 81, // Ban hành danh mục
    AlcImpAddProgram: 82, // phân bổ bổ sung Chi CTMT, mục tiêu khác
    InferiorOrgConfiguration: 108, //Đơn vị trực thuộc
}